<script setup>
import "@/assets/css/page.css"
</script>

<script>
export default {
  data() {
    return {
      walls: [require("@/assets/uploads/wall1.jpg"), require("@/assets/uploads/wall2.jpg"), require("@/assets/uploads/wall3.jpg"), require("@/assets/uploads/wall4.jpg"), require("@/assets/uploads/wall5.jpg"), require("@/assets/uploads/wall6.jpg"), require("@/assets/uploads/wall7.jpg"), require("@/assets/uploads/wall8.jpg"), require("@/assets/uploads/wall9.jpg"), require("@/assets/uploads/wall10.jpg")]
    }
  },
}
</script>



<template>
  <div id="main_body">
    <header class="main_header">
      <div class="header-wrapper">
        <div class="inner">
          <img src="@/assets/uploads/wall.jpg" class="attachment-full size-full">
        </div>
      </div>
    </header>

    <div class="index_1">

      <div class="container_content">
        <div class="content_wrapper">

          <div class="index_3">
            <div class="container_header">
              <p class="title">
                <ma>绿植墙</ma>
                相关案例
              </p>
              <p class="subtitle">已深耕植物墙领域多年，已成为行业内不折不扣的先行者。凭借对前沿材料与创新技术的精湛掌握，我们专业的植物墙团队致力于为您打造卓越非凡的绿色生命墙。我们不只是创造景观，更是用领先的理念和工艺，构筑可持续的绿色生态</p>
            </div>

            <div class="ff_pageList">
              <div class="mlist news module">
                <div class="module_container">
                  <div class="content_list clearfix">

                    <div v-for="w in walls">
                    <div class="item_block " style="animation-delay: 0s; visibility: visible; animation-name: fadeInUp;">
                      <a href="#" class="item_box">
                        <div class="item_img" style="padding:4px;">
                          <img :src="w" alt="">
                          <div class="item_mask"></div>
                        </div>
                        <div class="item_wrapper clearfix" style="display: none;">
                          <div class="item_info clearfix">
                            <p class="title ellipsis">室内植物墙应用</p>
                            <p class="subtitle ellipsis"></p>
                          </div>
                          <div class="item_des">
                            <p class="description">Indoor plant wall application</p>
                          </div>
                        </div>
                      </a>
                    </div>
                    </div>

                  </div>

                </div>

              </div>
            </div>


            <div class="clear"></div>
          </div>

        </div>

      </div>

      <div class="clear"></div>
    </div>
  </div>
</template>

<style scoped>

</style>